import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-onlineexam',
  templateUrl: './onlineexam.component.html',
  styleUrls: ['./onlineexam.component.css']
})
export class OnlineexamComponent implements OnInit {

  
  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.IsExamComp=false;
this.GetOnlineWorksheet();
  }
  SearchModel = {    
    StaffID:0,
    ClassID:0,
    SectionID:0,
  };
  WorksheetList=[];
  GetOnlineWorksheet() {
    
  this.spinnerService.show();
  this.learningservice.GetOnlineWorksheet(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.WorksheetList = data.WorksheetList;
    this.spinnerService.hide();
    // this.globalHelper.CheckActionStatus(data);
  });
};

WQuestionList=[];
WHQuestionList=[];
ChapterHeading:any;
BookTitle:any;
item:any;
ToDate:any;
StartDateTime:any;
EndDateTime:any;
GetWorksheetDetails(item) {
  
  this.item=item;
  this.ToDate=new Date(); 
  this.StartDateTime=new Date(this.item.StartDateTime);
  this.EndDateTime=new Date(this.StartDateTime.getTime() + item.Duration*60000);
  
  var itembo={   
    WorkSheetID:item.WorkSheetID,
    WSTestID:item.WSTestID,
  }
  this.spinnerService.show();
  this.learningservice.GetOnlineWorksheetHistory(JSON.stringify(itembo)).subscribe((data: any) => {
    this.WHQuestionList = data.WQuestionList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};
IsTime:any;
RefreshPage(){
  window.location.reload();

}
GetOnlineExamQuestion(item){
  this.IsExamComp=false;
  var itembo={
    
    WorkSheetID:item.WorkSheetID,
    WSTestID:item.WSTestID  
   
  }
  
  this.spinnerService.show();
  this.learningservice.GetOnlineWorksheetQuestion(JSON.stringify(itembo)).subscribe((data: any) => {
    this.WQuestionList = data.WQuestionList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
    this.TimeExpire=false; 
    this.TotalQ=this.WQuestionList.length;
    if(this.WQuestionList.length>0){
     //  alert(this.item.Duration);
     //  alert(this.item.StartDateTime);
     this.IsTime=false;
     if(this.item.Duration>0){
    
       this.startTimer(this.item.Duration);
       this.IsTime=true;
     }
    
     // alert(this.WQuestionList[0].AttemptTime);
   
     //  this.time.next(this.WQuestionList[0].AttemptTime);
     this.SetQuestion(0);
    }
  });

}
index=0;
TotalQ=0;
QuestionDetails:any;
SetQuestion(index){
 this.QuestionDetails=this.WQuestionList[index];

}
alertmsg:any;
PreviousQuestion(){
  this.index=this.index-1;
  this.SetQuestion(this.index);
}
AttemptTime:any;
responseData:any;
async  NextQuestion(i){
  this.alertmsg="";
  if(this.QuestionDetails.ROP1|| this.QuestionDetails.ROP2||this.QuestionDetails.ROP3||this.QuestionDetails.ROP4|| this.QuestionDetails.RFOP1!=null|| this.QuestionDetails.RFOP2!=null|| this.QuestionDetails.RFOP3!=null|| this.QuestionDetails.RFOP4!=null){
  var itembo={
    
    WorkSheetID:this.QuestionDetails.WorkSheetID,
    WSTestID:this.QuestionDetails.WSTestID,
    WSQuestionID:this.QuestionDetails.WSQuestionID,
    
    AttemptTime:this.AttemptTime,    
    QStatus:'A',  
    ROP1:this.QuestionDetails.ROP1,
    ROP2:this.QuestionDetails.ROP2,
    ROP3:this.QuestionDetails.ROP3,
    ROP4:this.QuestionDetails.ROP4,
    RFOP1:this.QuestionDetails.RFOP1,
    RFOP2:this.QuestionDetails.RFOP2,
    RFOP3:this.QuestionDetails.RFOP3,
    RFOP4:this.QuestionDetails.RFOP4,    
    // UserLoginID:this.UserDetails.UserLoginID,     
    // StaffID:this.UserDetails.StaffID,
   
  }

  this.spinnerService.show();
  this.learningservice.OnlineSaveTestQuestion(JSON.stringify(itembo)).subscribe((data: any) => {
    this.responseData = data;
    this.spinnerService.hide();
    // this.globalHelper.CheckActionStatus(data);
  });
 
this.WQuestionList[this.index]=this.QuestionDetails;
  this.index=this.index+1;
  if(this.index<this.TotalQ){
  this.SetQuestion(this.index);
  }
}
else{
this.alertmsg="please answer this question then next otherwise skip"
}
  }
async SkipQuestion(i){
  this.alertmsg="";
  var itembo={
    
    WorkSheetID:this.QuestionDetails.WorkSheetID,
    WSTestID:this.QuestionDetails.WSTestID,
    WSQuestionID:this.QuestionDetails.WSQuestionID,
    ROP1:this.QuestionDetails.ROP1,
    AttemptTime:this.AttemptTime,    
    QStatus:'S',  
    ROP2:this.QuestionDetails.ROP2,
    ROP3:this.QuestionDetails.ROP3,
    ROP4:this.QuestionDetails.ROP4,
    RFOP1:this.QuestionDetails.RFOP1,
    RFOP2:this.QuestionDetails.RFOP2,
    RFOP3:this.QuestionDetails.RFOP3,
    RFOP4:this.QuestionDetails.RFOP4,    
    // UserLoginID:this.UserDetails.UserLoginID,     
    // StaffID:this.UserDetails.StaffID,
   
  }

  this.spinnerService.show();
  this.learningservice.OnlineSaveTestQuestion(JSON.stringify(itembo)).subscribe((data: any) => {
    this.responseData = data;
    this.spinnerService.hide();
    // this.globalHelper.CheckActionStatus(data);
  });

  this.WQuestionList[this.index]=this.QuestionDetails;
  
   
  this.index=this.index+1;
  
  if(this.index<this.TotalQ){
   
  this.SetQuestion(this.index);
  }
  
  
}
IsExamComp=false;
async mSaveTestSubmit(p){
  var itembo={
   
    WorkSheetID:this.QuestionDetails.WorkSheetID,
    WSTestID:this.QuestionDetails.WSTestID,
    WSQuestionID:this.QuestionDetails.WSQuestionID,
   
   
  }
  this.spinnerService.show();
  this.learningservice.OnlineSaveTestSubmit(JSON.stringify(itembo)).subscribe((data: any) => {
    this.responseData = data;
    this.IsExamComp=true;
    this.GetWorksheetDetails(p)
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });


  
}


CheckedOne(item){
 
 if(item==1){
  if(this.QuestionDetails.QuestionTypeID==1 ||this.QuestionDetails.QuestionTypeID==3){
  this.QuestionDetails.ROP2=false;
  this.QuestionDetails.ROP3=false;
  this.QuestionDetails.ROP4=false;
  }
 }
 else if(item==2){
  if(this.QuestionDetails.QuestionTypeID==1 ||this.QuestionDetails.QuestionTypeID==3){
  this.QuestionDetails.ROP1=false;
 
  this.QuestionDetails.ROP3=false;
  this.QuestionDetails.ROP4=false;
  }
 }
 else if(item==3){
  if(this.QuestionDetails.QuestionTypeID==1 ||this.QuestionDetails.QuestionTypeID==3){
  this.QuestionDetails.ROP1=false;
  this.QuestionDetails.ROP2=false;
 
  this.QuestionDetails.ROP4=false;
  }
 }
 else if(item==4){
   if(this.QuestionDetails.QuestionTypeID==1 ||this.QuestionDetails.QuestionTypeID==3){
  this.QuestionDetails.ROP1=false;
  this.QuestionDetails.ROP2=false;
  this.QuestionDetails.ROP3=false;
   }
 }
}
maxTime: any=30
timer:number;
hidevalue:any;
Interval;
time: BehaviorSubject<string>=new BehaviorSubject('00:00');
startTimer(duration:number){
  clearInterval(this.Interval);
  
   this.timer=duration*60;

   this.UpdateTimeValue();
 this.Interval=setInterval(()=>{
this.UpdateTimeValue();
   },1000)
}
//     // 2
// var hours = Math.floor(timestamp / 60 / 60);

// // 37
// var minutes = Math.floor(timestamp / 60) - (hours * 60);

// // 42
// var seconds = timestamp % 60;
UpdateTimeValue(){
let mm :any=this.timer/60;
let ss:any=this.timer%60;  
mm=Math.floor(mm);
ss=Math.floor(ss);
const text= mm+ ':'+ ss;
this.AttemptTime=text;
this.time.next(text);
--this.timer;

if(this.timer<0){
 if(!this.TimeExpire){
  this.mSaveTestSubmit(this.QuestionDetails);
 }
  

this.TimeExpire=true; 
clearInterval(this.Interval);

}
}
TimeExpire=false;


WPQuestionList=[];
TotalAttempts:any;
TotalCorrect:any;
GetQuestionPreview(item){
  this.spinnerService.show();
  var itembo={   
    WorkSheetID:item.WorkSheetID,
    WSTestID:item.WSTestID,
  }
  this.learningservice.GetOnlineWorksheetQuestion(JSON.stringify(itembo)).subscribe((data: any) => {
    this.WQuestionList = data.WQuestionList;
   
    if(this.WQuestionList!=null){
      this.TotalAttempts=0;
      this.TotalCorrect=0;
    for (let index = 0; index < this.WQuestionList.length; index++) {
     
     if(this.WQuestionList[index].WSTestQuestionID>0){
     this.TotalAttempts=this.TotalAttempts+1;
     }
    

     if(this.WQuestionList[index].WSTestQuestionID>0 && ((this.WQuestionList[index].ROP4==true && this.WQuestionList[index].AROP4==true)|| (this.WQuestionList[index].ROP3==true && this.WQuestionList[index].AROP3==true)||(this.WQuestionList[index].ROP2==true && this.WQuestionList[index].AROP2==true)||(this.WQuestionList[index].ROP1==true && this.WQuestionList[index].AROP1==true)) && this.WQuestionList[index].QuestionTypeID==1){
       this.TotalCorrect=this.TotalCorrect+1;
      

      }
     
       if(this.WQuestionList[index].WSTestQuestionID>0 && ((this.WQuestionList[index].ROP4==true && this.WQuestionList[index].AROP4==true)|| (this.WQuestionList[index].ROP3==true && this.WQuestionList[index].AROP3==true)||(this.WQuestionList[index].ROP2==true && this.WQuestionList[index].AROP2==true)||(this.WQuestionList[index].ROP1==true && this.WQuestionList[index].AROP1==true)) && this.WQuestionList[index].QuestionTypeID==3){
       this.TotalCorrect=this.TotalCorrect+1;
       }

       if(this.WQuestionList[index].WSTestQuestionID>0 
         &&  this.WQuestionList[index].QuestionTypeID==2 
         &&((this.WQuestionList[index].AROP4!=false && this.WQuestionList[index].ROP4==this.WQuestionList[index].AROP4)
          || (this.WQuestionList[index].AROP3!=false && this.WQuestionList[index].ROP3==this.WQuestionList[index].AROP3) 
          || (this.WQuestionList[index].AROP2!=false && this.WQuestionList[index].ROP2==this.WQuestionList[index].AROP2)
          || (this.WQuestionList[index].AROP1!=false &&this.WQuestionList[index].ROP1==this.WQuestionList[index].AROP1))){
           this.TotalCorrect=this.TotalCorrect+1;
        
       }
       if(this.WQuestionList[index].WSTestQuestionID>0  &&  this.WQuestionList[index].QuestionTypeID==4
       &&  (this.WQuestionList[index].RFOP4!=null?this.WQuestionList[index].RFOP4.toUpperCase():'')==(this.WQuestionList[index].ARFOP4!=null?this.WQuestionList[index].ARFOP4.toUpperCase():'')
       &&  (this.WQuestionList[index].RFOP3!=null?this.WQuestionList[index].RFOP3.toUpperCase():'')==(this.WQuestionList[index].ARFOP3!=null?this.WQuestionList[index].ARFOP3.toUpperCase():'')
       &&  (this.WQuestionList[index].RFOP2!=null?this.WQuestionList[index].RFOP2.toUpperCase():'')==(this.WQuestionList[index].ARFOP2!=null?this.WQuestionList[index].ARFOP2.toUpperCase():'') 
       &&  (this.WQuestionList[index].RFOP1!=null?this.WQuestionList[index].RFOP1.toUpperCase():'')==(this.WQuestionList[index].ARFOP1!=null?this.WQuestionList[index].ARFOP1.toUpperCase():'') 
       )
       {
         this.TotalCorrect=this.TotalCorrect+1;
       }
      
     //   if(this.WQuestionList[index].WSTestQuestionID>0  &&  this.WQuestionList[index].QuestionTypeID==4
     //   && (this.WQuestionList[index].ARFOP4==this.WQuestionList[index].RFOP4) ){
     //  alert(this.WQuestionList[index].ARFOP4)
     //  alert(this.WQuestionList[index].RFOP4)
     //     this.TotalCorrect=this.TotalCorrect+1;
     //   }
     

       // if(this.WQuestionList[index].WSTestQuestionID>0 && ((this.WQuestionList[index].RFOP4==true && this.WQuestionList[index].ARFOP4==true)|| (this.WQuestionList[index].RFOP3==true && this.WQuestionList[index].ARFOP3==true)||(this.WQuestionList[index].RFOP2==true && this.WQuestionList[index].ARFOP2==true)||(this.WQuestionList[index].RFOP1==true && this.WQuestionList[index].ARFOP1==true)) && this.WQuestionList[index].QuestionTypeID==4){
       //   this.TotalCorrect=this.TotalCorrect+1;
       //   }
   }
   
    }

    this.spinnerService.hide();
    // this.globalHelper.CheckActionStatus(data);
  });

}
}
